import React from 'react';
import styled from '@emotion/styled';
import { useDispatch, useSelector } from 'react-redux';

import CTAButton from '../../../CTAButton';
import GetStartedModal from '../helpers/get-started-modal';
import ExistingClaim from './existingClaim';
import VideoThumbnails from '../helpers/video-thumbnails';

const Container = styled.div`
  max-width: 700px;
  margin: 0 auto;

  .btn-wrap {
    max-width: 80%;
    margin: 0 auto;

    .oc-cta-button {
      width: 100%;
    }
  }

  .full-width {
    width: 100%;
  }
`;

const HeaderWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: end;

  h2,
  h4 {
    line-height: 0.65;
  }

  .pink {
    color: #d40f7d;
  }

  .gray {
    color: #6d6d6d;
  }

  h4 {
    text-transform: uppercase;
  }

  .cta-side {
    display: flex;
    flex-direction: row;
    align-items: end;

    .cta-side-text {
      align-self: center;
    }
  }

  .panther {
    margin-right: 1rem;

    img {
      width: 100%;
    }
  }

  p {
    line-height: 1.5;
    font-size: 14px;
  }
`;

const ClaimsLanding = () => {
  const dispatch = useDispatch();
  const { formData } = useSelector(state => state);

  return (
    <>
    {formData.showExistingClaimPage && <ExistingClaim />}
    {!formData.showExistingClaimPage &&
      <Container>
        <HeaderWrap>
          <h4 className="gray">Roofing</h4>
          <h2>Warranty</h2>
          <h2 className="pink">Claims</h2>
          <div className="cta-side">
            <div className="panther">
              <img
                alt="panther"
                src="https://res.cloudinary.com/ocimages/image/upload/f_auto/v1576239079/use-everywhere/panther/hero-panther-point-right.png"
              />
            </div>
            <div className="cta-side-text">
              <p>In the unlikely event you experience a performance issue with your shingles,
                please watch the short videos below that explain the claims process.
                After watching, click Get Started to initiate your claim.</p>

            </div>
          </div>
          <div className='full-width'>
            <VideoThumbnails show='all' />
            <div className='btn-wrap'>
              <CTAButton
                onClick={() => dispatch({ type: "SHOW_MODAL", showModal: true })}
                element="button"
                text="Get Started"
                data-track="form-advance"
                data-track-form-name="Submit Claim"
                data-track-form-step="step 1 - get started"
              />
            </div>
          </div>
          <hr className="hr" />
          <p>
            If you are experiencing leaking issues please reach out to a
            contractor. Click <a href="/roofing/contractors">HERE</a> for our Find a Contractor page
            if you do not already have one.
            <br />
            <br />
            If you have already done so and are still experiencing leaking issues,
            please call 1-800-ROOFING.
          </p>
        </HeaderWrap>
        <GetStartedModal />
      </Container>
    }
    </>
  );
};

export default ClaimsLanding;
